import React from 'react';
import { Zap } from 'lucide-react';

// Aktiver Creator-Boost: boosted_until liegt in der Zukunft. Backend
// liefert boosted_until im Market-JSON; geringe Client/Server-Clock-
// Differenz ist an der 7-Tage-Grenze vernachlaessigbar.
export const isMarketBoosted = (market) =>
  !!(market && market.boosted_until && new Date(market.boosted_until) > new Date());

// Restlaufzeit eines Boosts in Tagen (aufgerundet), oder 0.
export const boostDaysRemaining = (market) => {
  if (!isMarketBoosted(market)) return 0;
  const ms = new Date(market.boosted_until).getTime() - Date.now();
  return Math.max(1, Math.ceil(ms / (1000 * 60 * 60 * 24)));
};

// "Boosted"-Badge. Orange-500 wie das Trending-Flame, aber mit Zap-Icon
// + Label klar von Trending unterscheidbar.
const BoostBadge = ({ size = 'sm', className = '' }) => {
  const sizing = size === 'md'
    ? 'text-xs px-2.5 py-1 gap-1.5'
    : 'text-[10px] px-2 py-0.5 gap-1';
  return (
    <span
      className={`inline-flex items-center font-bold uppercase tracking-wide rounded-full bg-orange-500 text-white shadow-sm ${sizing} ${className}`}
    >
      <Zap className={size === 'md' ? 'h-3.5 w-3.5' : 'h-3 w-3'} fill="currentColor" />
      Boosted
    </span>
  );
};

export default BoostBadge;
